import { createContext, useContext, useState, useEffect } from "react";
import { useSocket } from "./SocketContext";
import { BattleEvents } from "../constants";

const BattleContext = createContext();
export const useBattle = () => useContext(BattleContext);

export const BattleProvider = ({ children }) => {
  const [battleData, setBattleData] = useState({
    player1: null,
    player2: null,
    monster: null,
  });
  const { socket } = useSocket();
  const [isBattleStarted, setIsBattleStarted] = useState(false);
  const [isBattleEnded, setIsBattleEnded] = useState(false);
  const [battleResult, setBattleResult] = useState(null);
  const [season, setSeason] = useState(null);

  useEffect(() => {
    if (!socket) return;

    const onReady = (data) => {
      console.log("Player is ready"); 
      setBattleData(prev => ({
        ...prev,
        monster: data.monster,
      }));
    }

    const onStart = ({ user, opponent ,monster}) => {
      setBattleData({ player1: { ...user, score: 0 }, player2: { ...opponent, score: 0 }, monster});
      setIsBattleStarted(true);
    };

    const onUpdate = (data) => {
      console.log("Battle updated", data);
      setBattleData(prev => {
        // Eğer güncelleme player1'den geldiyse

        if (data.from === prev.player1?._id) {
          return {
            ...prev,
            player1: {
              ...prev.player1,
              score: (prev.player1.score || 0) + data.damage,
              criticalHit: data.criticalHitOccurred,
              doubleDamage: data.doubleDamageOccurred,
              card: data.card,
            },
           
          };
        }
        // Yoksa player2 için aynı işlemi yap
        if (data.from === prev.player2?._id) {
          return {
            ...prev,
            player2: {
              ...prev.player2,
              score: (prev.player2.score || 0) + data.damage,
              criticalHitOccurred: data.criticalHitOccurred,
              doubleDamageOccurred: data.doubleDamageOccurred,
              card: data.card,
            }
          };
        }
        return prev;
      });
    };
    const onEnd = ({result}) => {
      console.log("Battle ended", result);
      setBattleResult(result);
      setIsBattleEnded(true);
      setIsBattleStarted(false);
    };

   const onDisconnect = () => {
      setIsBattleStarted(false);
      setIsBattleEnded(false);
      setBattleData({ player1: null, player2: null });
    }
    socket.on(BattleEvents.READY, onReady);
    socket.on(BattleEvents.START, onStart);
    socket.on(BattleEvents.UPDATE, onUpdate);
    socket.on(BattleEvents.END, onEnd);
    socket.on("disconnect", onDisconnect);

    return () => {
      socket.off(BattleEvents.READY, onReady);
      socket.off(BattleEvents.START, onStart);
      socket.off(BattleEvents.UPDATE, onUpdate);
      socket.off(BattleEvents.END, onEnd);
      socket.off("disconnect", onDisconnect);
    };
  }, [socket]);

  return (
    <BattleContext.Provider
      value={{
        battleData,
        setBattleData,
        isBattleStarted,
        setIsBattleStarted,
        isBattleEnded,
        setIsBattleEnded,
        battleResult,
        setBattleResult,
        season,
        setSeason,
      }}
    >
      {children}
    </BattleContext.Provider>
  );
};
